<div class="page-wrapper">

  <div class="left-panel">

			<img class="circuit-bg" src="assets/circuit-bg.png" alt="" />

			<div class="top-bar">
				<div class="siemens-logo">
					<img src="assets/logo.svg" class="siemens-logo-img" alt="siemens-logo-img" />
				</div>

			</div>

			<div class="brand-label">
				<img class="noedra-node-logo" src="assets/suit_icon.svg" alt="noedra-img" />
				<div class="noedra-node-heading">Noedra Node</div>
			</div>
  </div>

  <div class="right-panel">
    <div class="content-wrapper">

      <section class="terms-section">
        <h2 class="section-title">Noedra Node Cloud</h2>
        <ul class="link-list">
          <li>
            <a href="../assets/docs/Master_Agreement_for_Sensproducts_Version_APAC_Revision_August_2025.pdf" target="_blank">
              Master Terms & Conditions Cloud - Asia Pacific & China Region
            </a>
          </li>
          <li>
            <a href="../assets/docs/Master_Areement_for_Sensproducts_Version_EMEA_Revision_August_2025.pdf" target="_blank">
              Master Terms & Conditions Cloud - Europe,Middle East & Africa Region
            </a>
          </li>
          <li>
            <a href="../assets/docs/Master_Agreement_for_Sensproducts_Version_AMERICAS_Revision_August_2025.pdf" target="_blank">
              Master Terms & Conditions Cloud - Americas Region
            </a>
          </li>
          <li>
            <a href="https://aws.amazon.com/service-terms/" target="_blank">
              AWS Terms & Conditions
            </a>
          </li>
          <li>
            <a href="../assets/docs/Sensformer_AcceptableUsePolicy v1.0.pdf" target="_blank">
              Acceptable Use Policy
            </a>
          </li>
          <li>
            <a href="../assets/docs/Data_Privacy_Terms_alt.pdf" target="_blank">
              Data Privacy
            </a>
          </li>
        </ul>
      </section>

      <section class="terms-section">
        <h2 class="section-title">SLCs</h2>
        <ul class="link-list">
          <li>
            <a href="../assets/docs/SLC.pdf" target="_blank">
              SLCs
            </a>
          </li>
        </ul>
      </section>

    </div>
  </div>

</div>

<footer class="app-footer">
  <span>
    Siemens Energy is a trademark licensed by Siemens AG.  © Siemens Energy , 2026
  </span>
</footer>
